import { useQuery } from '@tanstack/vue-query'
import { investorsQueryKeys } from '../investorsQueryKeys'
import { getBankVerificationStatusCounts } from '../investorsEndpoints'

export function useBankVerificationStatusCountsQuery() {
  return useQuery({
    queryKey: investorsQueryKeys.bankVerificationStatusCounts(),
    queryFn: getBankVerificationStatusCounts,
    staleTime: 1000 * 30,
  })
}
